import React from 'react';
import { Outlet} from 'react-router-dom';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Background from "../Components/Background";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { useState } from 'react';
import HomePage from './HomePage';

export const ColorModeContext = React.createContext({ toggleColorMode: () => {} });

function Layout() {
 
  
    return (
      <>

    
<Outlet/>
  
 
  </>
    );
}


export default Layout;